import axios from 'axios'
import React, {useContext, useState, useEffect, useRef} from 'react'
import {UserContext} from "./UserContext";

const ChatBot = () =>{
    const [chatBotIsOpened,setChatBotIsOpened] = useState(false)
    const {backEndUrl} = useContext(UserContext)
    const messagesEndRef = useRef(null)
    const chatBodyRef = useRef(null)
    
    const chat = () =>{
        setChatBotIsOpened(!chatBotIsOpened)
    }

    const [chatText,setChatText] = useState("")
    const [messages,setMessages] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }

    useEffect(() => {
        scrollToBottom()
    }, [messages])

    const submit = async(e) =>{
        e.preventDefault()
        if(!chatText.trim() || isLoading) return

        const userMessage = chatText.trim()
        setChatText("")
        setIsLoading(true)

        // Add user message immediately
        setMessages((prev) => [...prev, { text: userMessage, sender: 'user' }])

        try {
            const Message = new FormData()
            Message.append("userInput", userMessage)
            const response = await axios.post(`${backEndUrl}/chatbot`,Message)

            const botMessage = { text: response.data.message, sender: 'bot' };
            setMessages((prev) => [...prev, botMessage]);

        } catch (error) {
            const errorMessage = { text: `Error: ${error.message}`, sender: 'bot' };
            setMessages((prev) => [...prev, errorMessage]);
        } finally {
            setIsLoading(false)
        }

    }


    return(
        <div className="chatbot-container">
            <button className='chatbot-toggle' onClick={chat} aria-expanded={chatBotIsOpened}>
                <img className={"chatbot-image"} src="/images/chat-bot_icon2.png" alt='Open chatbot'/>
                <span>Ask CliffBot</span>
            </button>

            {chatBotIsOpened &&
                <div className="chatbot-panel">
                    <div className="chatbot-header">
                        <span>CliffBot</span>
                        <button className="icon-button" onClick={chat} aria-label="Close chatbot">×</button>
                    </div>

                    <div className="chatbot-body" ref={chatBodyRef}>
                        <div className="chatbot-messages">
                            {messages.length === 0 && (
                                <p className='body-text welcome-message'>Hello! How can I help you today? Type <strong>quit</strong> to close the conversation.</p>
                            )}
                            {messages.map((message,index)=>(
                                <div 
                                    className={`chat-message ${message.sender === 'user' ? 'chat-message-user' : 'chat-message-bot'}`} 
                                    key={index}
                                >
                                    {message.text}
                                </div>
                            ))}
                            {isLoading && (
                                <div className="chat-message chat-message-bot">
                                    <span className="typing-indicator">CliffBot is typing...</span>
                                </div>
                            )}
                            <div ref={messagesEndRef} />
                        </div>

                        <form onSubmit={submit} className="chat-form">
                            <input 
                                type="text" 
                                placeholder="Ask anything" 
                                value={chatText} 
                                onChange={(e)=>setChatText(e.target.value)}
                                disabled={isLoading}
                            />
                            <button type="submit" className="btn btn-accent" disabled={isLoading || !chatText.trim()}>
                                {isLoading ? '...' : 'Send'}
                            </button>
                        </form>
                    </div>

                </div>
            }

        </div>
    )

}

export default ChatBot